import React from 'react';
import PropTypes from 'prop-types';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { FDStack } from '@facet-wealth/design';
import { impactOverrides } from './overrides';
import { ImpactPaper } from './paper';

export function StandardImpact({ resource }) {
  return (
    <ImpactPaper>
      <FDStack direction="column" justifyContent="center" alignItems="center" height="100%">
        <MetaControl resource={resource} metaOverrideSet={impactOverrides} attrName="headline" />
        <MetaControl resource={resource} metaOverrideSet={impactOverrides} attrName="description" />
        <MetaControl resource={resource} metaOverrideSet={impactOverrides} attrName="value" />
      </FDStack>
    </ImpactPaper>
  );
}

StandardImpact.propTypes = {
  resource: PropTypes.object.isRequired,
};
